import { createFileRoute } from '@tanstack/react-router';
import { trendingStaticData } from '../trending';

export const Route = createFileRoute('/_private-routes/trending/influencers')({
  staticData: trendingStaticData
});
